import { getEditTypes } from '../../../delegatorUtils';
import { FormControl, FormGroup } from '@angular/forms';
import { EditPermissions } from '../../../../../../../shared/models';
import { required } from '../../../../../../../shared/utils';

export interface ApiEndNodeData {
  name: string,
  description: string,
  responseHttpStatus: string,
  responseBody: string,
  responseContentType: string
}

export class apiEndNode {

  integration: any = {};

  constructor(formData: ApiEndNodeData) {
    this.integration = {
      'integrationType': 'endNode',
      'endNode': {
        'endNodeType': 'api'
      }
    };
    this.setNodeData(formData);
  }

  static toForm(stepData: { [index: string]: any }, editPermissions: EditPermissions): FormGroup {
    const {editMenuTextOnly, editFlows} = getEditTypes(editPermissions);
    const formData = this.getFromData(stepData);

    return this.buildForm(formData, editFlows)
  }

  private static getFromData(stepData: { [index: string]: any }): ApiEndNodeData {
    const integration = stepData?.integration ? stepData?.integration : {};
    const endNode = integration?.endNode ? integration?.endNode : {};
    const outputVars = endNode?.outputVars ? endNode?.outputVars : {};

    return {
      name: integration.name ? integration.name : '',
      description: integration.description ? integration.description : '',
      responseHttpStatus: outputVars.responseHttpStatus ? outputVars.responseHttpStatus : '',
      responseBody: outputVars.responseBody ? outputVars.responseBody : '',
      responseContentType: outputVars.responseContentType ? outputVars.responseContentType : ''
    }
  }

  private static buildForm(formData: ApiEndNodeData, editFlows: boolean): FormGroup {
    return new FormGroup({
      name: new FormControl({
        value: formData.name,
        disabled: !editFlows
      }, required('Name')),
      description: new FormControl({
        value: formData.description,
        disabled: !editFlows
      }, required('Description')),
      responseHttpStatus: new FormControl({
        value: formData.responseHttpStatus,
        disabled: !editFlows
      }, required('HTTP Status')),
      responseBody: new FormControl({
        value: formData.responseBody,
        disabled: !editFlows
      }, required('Response Body')),
      responseContentType: new FormControl({
        value: formData.responseContentType,
        disabled: !editFlows
      }, required('Response Content Type'))
    });
  }

  get nodeData(): {} {
    return {
      integration: this.integration,
      'type': 'integration',
      metadata: {
        nodeVersion: '1.0.0'
      }
    };
  }

  setNodeData(formData: ApiEndNodeData) {
    const {name, description, responseHttpStatus, responseBody, responseContentType} = formData;

    const outputVars = {
      responseHttpStatus,
      responseBody,
      responseContentType
    }

    const endNode = {
      endNodeType: 'api',
      outputVars
    }

    this.integration = {
      ...this.integration,
      name,
      description,
      endNode
    }
  }
}

/*
json: {
  integration: {
    name: '',
    description: '',
    integrationType: 'endNode',
    endNode: {
      endNodeType: 'api',
      outputVars: {
        responseHttpStatus: '',
        responseBody: '',
        responseContentType: '',
      },
    },
},
  type: 'integration',
},*/